import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
  [ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_ROLES].GET_REPORTS_FINANCE_BY_ROLES]: {
    url: '/company/:companyId/reports/finance/by_roles/',
  },
}